import loadable from '@react-loadable/revised';
import IconCallToUs from 'assets/contact/call.inline.svg';
import IconWriteToUs from 'assets/contact/mail.inline.svg';
import Footer from 'components/Footer';
import Layout from 'components/Layout';
import ToUsItem from 'components/pages/contact/items/ToUsItem';
import ChipsView from 'components/pages/contact/view/ChipsView';
import { StaticImage } from 'gatsby-plugin-image';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import useSearchParams, { getSearchParam } from 'hooks/useSearchParams';
import React, { useEffect, useRef, useState } from 'react';
import { scrollInto } from 'utils/helper';

const LazyContactForm = loadable({
	loader: () => import('components/pages/contact/view/ContactForm'),
	loading: () => <div />
});

// TODO: better animation
export default function ContactPage() {
	const { location, searchLangParams } = useSearchParams();
	const { t } = useTranslation();
	const refSubject = useRef();

	const items = [
		{ id: 1, label: t('pageContact.subject.li.1')},
		{ id: 2, label: t('pageContact.subject.li.2')},
		{ id: 3, label: t('pageContact.subject.li.3')},
		{ id: 4, label: t('pageContact.subject.li.4')},
		{ id: 5, label: t('pageContact.subject.li.5')},
		{ id: 6, label: t('pageContact.subject.li.6')},
		{ id: 7, label: t('pageContact.subject.li.7')},
		{ id: 8, label: t('pageContact.subject.li.8')},
	];

	const [itemResized, setItemResized] = useState(items[0]);

	useEffect(() => {
		if(getSearchParam(location.search) === searchLangParams.subject.enterprise) {
			scrollInto(refSubject, 200);
			setItemResized(items[3]);
		} else if(getSearchParam(location.search) === searchLangParams.subject.education) {
			scrollInto(refSubject, 200);
			setItemResized(items[2]);
		}
	}, []);

	const handleChooseItem = item => {
		setItemResized(item);
	};

	return (
		<Layout>
			<div>
				<div className='hidden sm:block absolute right-0 sm:w-50/100 top-0 sm:pt-40'>
					<StaticImage src='../../../assets/contact/smartfaktor-contact.png' alt="" placeholder='none' />
				</div>

				<div className='layout sm:h-220 lg:h-250 lg:mb-10 xl:h-300 xl:mb-20'>
					<h1 className='sm:text-shadow pt-40 sm:pt-60 lg:pt-80 xl:pt-120'>{t('pageContact.h1')}<span className='text-green-1 font-normal text-shadow-none'>_</span></h1>

					<div className='w-full sm:w-50/100 2xl:h-160'>
						<p className='font-bold'>{t('pageContact.desc')}</p>
					</div>
				</div>

				<div className='sm:hidden w-full'>
					<StaticImage src='../../../assets/contact/mobile-smartfaktor-contact.png' alt="" placeholder='none' />
				</div>
			</div>

			<div className='flex items-center justify-center flex-col sm:flex-row sm:pt-50'>
				<ToUsItem Icon={IconCallToUs} label={t('pageContact.callToUs')} href='tel:780 780 216'>
					<p>+48 780 780 216,</p>
					<p>+48 780 780 154</p>
				</ToUsItem>
				<ToUsItem Icon={IconWriteToUs} label={t('pageContact.writeToUs')} href='mailto:hello@finteq.pl' tw='mt-30 sm:mt-0 sm:ml-24'>
					hello@finteq.pl
				</ToUsItem>
			</div>

			<div ref={refSubject} className='pt-20 mt-40'>
				<h2 className='mb-20 sm:mb-35 text-center'>{t('pageContact.subject.h2')}<span className='text-green-1 font-normal text-shadow-none'>_</span></h2>
				<ChipsView
					items={items}
					itemResized={itemResized}
					onChipClick={handleChooseItem}
				/>
			</div>

			<div className='flex justify-center mt-20 relative'>
				<div className='w-full max-w-500 sm:w-70/100 lg:w-50/100 flex justify-center'>
					<LazyContactForm item={itemResized} onSuccess={() => handleChooseItem(items[0])} />
				</div>

				<div className='max-w-150 sm:max-w-full absolute bottom-0 left-0 -mb-03 -ml-45 xl:ml-120'>
					<StaticImage src='../../../assets/contact/contact-with-us.png' alt="" />
				</div>
			</div>

			<Footer />
		</Layout>
	);
}
